import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminplanaccion',
  templateUrl: './adminplanaccion.component.html',
  styleUrls: ['./adminplanaccion.component.scss']
})
export class AdminplanaccionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
